<template>
  <el-row class="student-doc">
    <el-col>
      <el-row class="activity-header mb-3">
        <el-col>
          <div class="header-item flex-between flex-align-center">
            <div class="flex">
              <el-button
                v-if="![6, 7].includes(userInfo.role_id)"
                type="out-line"
                class="return-btn"
                icon="el-icon-arrow-left"
                size="small"
                @click="goBack"
              ></el-button>
              <el-button type="primary" size="small" @click="exportTable">导出信息</el-button>
            </div>
            <div class="data-range">统计范围：{{ countArea }}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="mb-3" type="flex">
        <el-col :span="18" class="student-course-info">
          <el-row type="flex" class="flex-align-center">
            <el-col :span="7" class="student-base-info">
              <div class="student-info flex-align-center">
                <div class="info-item">
                  <img src="@/assets/images/course/headbig_icon_def.png" alt="" />
                </div>
                <div class="info-item flex-column">
                  <div class="student-name item-content">
                    {{ studentData.detail.firstname }}
                  </div>
                  <div class="institute-name item-title">
                    {{ studentData.detail.college }}
                  </div>
                  <div class="group-name item-title">
                    {{ studentData.detail.group }}
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="17" class="student-study-info">
              <el-row class="course-info" :gutter="20">
                <el-col class="info-item flex-column" :span="4">
                  <div class="item-content">
                    <span class="data">
                      {{ (studentData.detail.spend_time / 60).toFixed(0) || 0 }}mins
                    </span>
                  </div>
                  <div class="item-title" style="position: relative">
                    学习时长
                    <el-tooltip class="item" effect="light" placement="bottom">
                      <div slot="content">
                        <div>两次操作间隔超过退出时间，将视为退出。</div>
                        <div>该时间段不纳入学习时长的统计</div>
                      </div>
                      <i class="mdi mdi-help-circle-outline" style="position: absolute"></i>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col class="info-item flex-column" :span="4">
                  <div class="item-content">
                    <span class="data">
                      {{ Number(studentData.detail.score).toFixed(2) || 0 }}
                    </span>
                  </div>
                  <div class="item-title">课程成绩</div>
                </el-col>
                <el-col class="info-item flex-column" :span="4">
                  <div class="item-content">
                    {{ studentData.detail.discussion || 0 }}/{{ studentData.detail.post || 0 }}
                  </div>
                  <div class="item-title">发帖数/回帖数</div>
                </el-col>
                <el-col class="info-item flex-column" :span="4">
                  <div class="item-content">
                    {{ studentData.detail.reply_post || 0 }}
                  </div>
                  <div class="item-title">教师回帖数</div>
                </el-col>
                <el-col class="info-item flex-column" :span="4">
                  <div class="item-content">
                    <span class="data">{{ studentData.detail.access_day || 0 }}天</span>
                  </div>
                  <div class="item-title">课程浏览天数</div>
                </el-col>
                <el-col class="info-item flex-column" :span="4">
                  <div class="item-content">
                    <span class="data">
                      {{ (studentData.detail.access_num / 60).toFixed(0) || 0 }}mins
                    </span>
                  </div>
                  <div class="item-title">课程浏览数</div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="6">
          <el-row type="flex" class="course-progress flex-center flex-align-center">
            <el-col :span="12" class="progress-item flex-column mb-3">
              <div class="progress-title">
                <img class="progress-icon" src="@/assets/images/course/icon_donut.png" alt="" />
                <div class="item-title">学习进度</div>
              </div>
              <div
                :class="percentage < 100 ? 'red-text item-progress' : 'green-text item-progress'"
              >
                {{ percentage < 100 ? '未完成' : '已完成' }}
              </div>
              <div class="item-count">剩余{{ 100 - studentData.detail.progress }}%</div>
              <div class="progress-item"></div>
            </el-col>
            <el-col :span="12">
              <el-progress
                type="dashboard"
                :percentage="percentage > 100 ? 100 : percentage"
                :color="colors"
              ></el-progress>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="mb-3">
        <el-col>
          <el-table
            id="student-detail"
            :data="studentTableData"
            row-key="id"
            default-expand-all
            :tree-props="{ children: 'children' }"
          >
            <el-table-column prop="title" label="活动名称">
              <!-- <template slot-scope="scope">
                <span v-if="scope.row.isTheme">{{ scope.row.name }}</span>
                <span v-if="scope.row.isSubTheme">{{ scope.row.name }}</span>
                <span v-if="scope.row.isActivity">
                  {{ scope.row.name }}
                </span>
              </template> -->
            </el-table-column>
            <el-table-column prop="module" label="活动类型"></el-table-column>
            <el-table-column prop="finish_setting" label="活动完成条件">
              <template slot-scope="scope">
                <div v-html="scope.row.finish_setting"></div>
              </template>
            </el-table-column>
            <el-table-column width="300" prop="studySituation" label="学习情况"></el-table-column>
            <el-table-column prop="access_num" label="访问次数"></el-table-column>
            <el-table-column prop="last_access_time" label="最后学习时间"></el-table-column>
            <el-table-column prop="finish_status" label="活动完成情况">
              <template slot-scope="scope">
                <span v-if="scope.row.finish_status === 0" class="green-text">未完成</span>
                <span v-else-if="scope.row.finish_status === 1" class="red-text">已完成</span>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="得分"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row class="chart-box">
        <el-col>
          <div class="chart-title">每周访问数统计</div>
          <div id="week-access-chart" :style="{ height: '300px' }"></div>
        </el-col>
      </el-row>
      <el-row class="week-access">
        <el-col>
          <div v-for="(gitem, gindex) in splitAccessGroupData" :key="gindex">
            <el-table
              :header-cell-class-name="setFirstColumnClass"
              :cell-class-name="setFirstColumnClass"
              border
              :data="tableColumn[gindex]"
            >
              <el-table-column
                :width="
                  gitem.x.length < 12
                    ? rowItem.accessWeek == 'week0'
                      ? firstColumnWidth
                      : otherColumnWidth
                    : ''
                "
                :prop="rowItem.accessWeek"
                :label="rowItem.accessTimes"
                v-for="rowItem in gitem.x"
                :key="rowItem.id"
                align="center"
              >
                <template slot-scope="scope">
                  <div :ref="rowItem.accessWeek == 'week0' ? 'week0' : 'otherWeek'">
                    {{ scope.row[rowItem.accessWeek] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      tableColumn: [],
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#3294F6', percentage: 100 },
      ],
      studentData: {
        access: [],
        table: [],
        detail: { progress: '0', score: 0 },
      },
      teachData: [],
      courseAndPlatFormChart: null,
      screenWidth: '',
      screenHeight: '',
      firstColumnWidth: 127,
      otherColumnWidth: 125,
    }
  },
  computed: {
    ...mapState({
      userInfo(state) {
        return state.commom.userInfo
      },
      roleList(state) {
        return state.commom.roleList
      },
      routesStartPath() {
        console.log('this.$route.path', this.$route.path)
        return this.$route.path
      },
    }),
    // 统计范围
    countArea() {
      return (
        this.$store.state.course.courseInfo.statistics_start_time.split('-').join('.') +
        '-' +
        this.$store.state.course.courseInfo.statistics_end_time.split('-').join('.')
      )
    },
    // 每周访问数统计图表数据X轴文本处理
    weekData() {
      let xDataArray = []
      for (let i in this.accessData.x) {
        xDataArray.push(`第${this.toChineseNum(+i + 1)}周`)
      }
      return xDataArray
    },
    // 学习进度
    percentage() {
      return Number(this.studentData.detail.progress)
    },
    // 每周访问数统计图表数据
    accessData() {
      let data = {}
      let x = []
      let y = []
      for (let i of this.studentData.access) {
        x.push(i.title)
        y.push(i.num)
      }
      data['x'] = x
      data['y'] = y
      console.log(data, 'accessdata')
      return data
    },
    // 接口每周访问数数组长度
    accessDataLength() {
      return this.accessData.x.length
    },
    // 每周访问数表格模块,每一行显示12个-按每一组12个,算出共多少组
    splitAccessGroupData() {
      let groupData = []
      // 以12个为一组，算出组数
      let groupNums = Math.ceil(this.accessDataLength / 12)
      for (let i = 0; i < groupNums; i++) {
        let xData = []
        let yData = []
        // 按每次push12个作为一组数据,遍历每周访问量的统计数据
        for (let j = 0; j < 12 && i * 12 + j < this.accessDataLength; j++) {
          xData.push(this.accessData.x[i * 12 + j])
          yData.push(this.accessData.y[i * 12 + j])
        }
        console.log('xdata', xData)
        console.log('ydata', yData)
        // 将每组数据分好x轴和y轴作为对象,push到数组中
        groupData.push({ x: this.accessTableRow(xData), y: this.accessTableColumn(yData) })
      }
      return groupData
    },
    // 学生活动表格数据
    studentTableData() {
      let data = this.studentData.table.map(item => {
        let studySituation = ''
        for (let key in item.situation) {
          if (item.situation[key]) {
            switch (key) {
              case 'numfiles':
                studySituation === ''
                  ? (studySituation += `作业附件数${item.situation[key]}`)
                  : (studySituation += `，作业附件数${item.situation[key]}`)
                break
              case 'submit_num':
                studySituation === ''
                  ? (studySituation += `提交测验${item.situation[key]}次`)
                  : (studySituation += `，提交测验${item.situation[key]}次`)
                break
              case 'discussion':
                studySituation === ''
                  ? (studySituation += `主题数${item.situation[key]}`)
                  : (studySituation += `，主题数${item.situation[key]}`)
                break
              case 'post':
                studySituation === ''
                  ? (studySituation += `回帖数${item.situation[key]}`)
                  : (studySituation += `，回帖数${item.situation[key]}`)
                break
              case 'viewtime':
                studySituation === ''
                  ? (studySituation += `视频查看时长${(item.situation[key] / 60).toFixed(0)}min`)
                  : (studySituation += `，视频查看时长${(item.situation[key] / 60).toFixed(0)}min`)
                break
              case 'spend_time':
                studySituation === ''
                  ? (studySituation += `学习时长${(item.situation[key] / 60).toFixed(0)}min`)
                  : (studySituation += `，学习时长${(item.situation[key] / 60).toFixed(0)}min`)
                break
            }
          }
        }
        return {
          studySituation: studySituation,
          ...item,
        }
      })
      console.log('data', data)
      return data
    },
  },
  mounted() {
    console.log('1', this.toChineseNum(1))
    this.getStudentDocDetailApi()
    this.screenWidth = document.body.clientWidth //监听页面缩放
    this.screenHeight = document.body.clientHeight
    // this.$nextTick(() => {
    //   console.log('=================================================================')
    //   console.log('1width', this.$refs)
    //   console.log('=================================================================')

    //   this.firstColumnWidth = this.$refs.week0[0].offsetWidth + 20
    //   this.otherColumnWidth = this.$refs.otherWeek[0].offsetWidth + 20
    // })

    window.onresize = () => {
      return (() => {
        console.log('1width', this.$refs.week0[0].offsetWidth)
        console.log('2width', this.$refs.otherWeek[0].offsetWidth)
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
        // this.firstColumnWidth = this.$refs.week0[0].offsetWidth + 20
        // this.otherColumnWidth = this.$refs.otherWeek[0].offsetWidth + 20
      })()
    }
  },
  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  methods: {
    // 每周访问数统计表格日期
    accessTableRow(groupItem) {
      let tableRow = [{ id: 0, accessTimes: '日期', accessWeek: 'week0' }]
      for (let index in groupItem) {
        tableRow.push({
          id: +index + 1,
          accessTimes: groupItem[index],
          accessWeek: 'week' + Number(+index + 1),
        })
      }
      return tableRow
    },
    // 每周访问数统计表格访问数
    accessTableColumn(groupItem) {
      console.log('groupitem', groupItem)
      let columnObj = { week0: '访问数' }
      for (let index in groupItem) {
        let rowIndex = +index + 1
        columnObj['week' + rowIndex] = groupItem[index]
      }
      console.log('columnObj', columnObj)

      this.tableColumn.push([columnObj])
      console.log('this.tableColumn', this.tableColumn)
    },
    // 获取中文
    toChineseNum(index) {
      const number = parseInt(index, 0)
      const singleWord = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '零']
      const unit = ['十', '百']
      const indexFirstNum = parseInt(number.toString().substr(0, 1), 0)
      const indexSecondNum = parseInt(number.toString().substr(1, 1), 0)
      const indexThirdNum = parseInt(number.toString().substr(2, 1), 0)
      if (number < 10) {
        return singleWord[number]
      } else if (number < 100) {
        if (indexFirstNum === 1 && indexSecondNum === 0) {
          //10为特殊情况
          return unit[0]
        }
        return singleWord[indexFirstNum] + unit[0] + singleWord[indexSecondNum]
      } else {
        if (indexThirdNum === 0 && indexSecondNum === 0) {
          // 109 和 190 两种类型的特殊情况
          return singleWord[indexFirstNum] + unit[1]
        } else if (indexSecondNum === 0) {
          return singleWord[indexFirstNum] + unit[1] + singleWord[10] + singleWord[indexThirdNum]
        }
        return (
          singleWord[indexFirstNum] +
          unit[1] +
          singleWord[indexSecondNum] +
          unit[0] +
          singleWord[indexThirdNum]
        )
      }
    },
    // 获取学员档案详情
    async getStudentDocDetailApi() {
      await this.$store
        .dispatch('course/getStudentDocDetail', {
          course_id: Number(this.$route.query.courseId),
          user_id: Number(this.$route.query.userId),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            let { access, detail, table } = res.data
            this.studentData.access = access
            this.studentData.detail = detail
            this.studentData.table = table
            console.log('studentData', this.studentData)
            this.iniWeekAccessChart(this.accessData)
            console.log('splitAccessGroupData', this.splitAccessGroupData)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 初始化每周访问数统计图表
    iniWeekAccessChart(data) {
      var chart = this.$echarts.init(document.getElementById('week-access-chart'))
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: 50,
          right: 40,
        },
        xAxis: {
          type: 'category',
          data: this.weekData,
        },
        yAxis: {
          type: 'value',
          name: '访问数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [0, 50, 30, 0],
            fontSize: '12',
            align: 'center',
          },
        },
        series: [
          {
            name: '浏览次数',
            data: data.y,
            type: 'line',
            itemStyle: {
              color: '#3283F6',
            },
          },
        ],
      }
      chart.setOption(option)
      this.weekAccessChart = chart
    },
    getReSize() {
      let chartArr = [this.weekAccessChart]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    setFirstColumnClass({ columnIndex }) {
      if (columnIndex === 0) {
        return 'first-column'
      } else {
        return 'other-column'
      }
    },
    // 导出表格
    exportTable() {
      //导出名称
      let excelName = '学员档案' + new Date().getTime() + '.xlsx'
      const xlsxParam = { raw: true } //转化成Excel使用原始格式
      const table_book = this.$XLSX.utils.table_to_book(
        document.querySelector('#student-detail'),
        xlsxParam
      )
      const table_write = this.$XLSX.write(table_book, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        this.$FileSaver.saveAs(
          new Blob([table_write], { type: 'application/octet-stream' }),
          excelName
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, table_write)
      }
      return table_write
    },
  },
  firstColumnWidth() {
    let i = document.getElementsByClassName('first-column')[0].offsetWidth
    return i
  },
  otherColumnWidth() {
    let i = document.getElementsByClassName('other-column')[0].offsetWidth

    return i
  },
}
</script>
<style lang="scss" scoped>
.student-doc {
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
    }
    .cell {
      color: #6c757d;
    }
  }
  .activity-header {
    .header-item {
      .return-btn {
        color: rgba(50, 148, 246, 1);
        border-color: rgba(50, 148, 246, 1);
      }
      .activity-title {
        font-size: 16px;
        font-weight: bold;
        color: #343a40;
      }
      .activity-condition {
        font-size: 14px;
        color: #98a6ad;
      }
    }
  }

  .data-range {
    font-size: 14px;
    color: #6c757d;
  }
  .student-course-info {
    margin-right: 24px;
    padding: 24px 20px 0px 48px !important;
    border: 1px solid #e5e8eb;
    .student-info {
      text-align: center;
      .info-item {
        margin-right: 24px;
        .item-content {
          font-size: 24px;

          font-weight: bold;
          color: #343a40;
        }
        .item-title {
          font-size: 16px;
          color: #6c757d;
        }
      }
    }
    .course-info {
      border-left: 1px solid #e5e8eb;
      text-align: center;
      .info-item {
        .item-content {
          white-space: nowrap;
          font-size: 32px;
          font-weight: bold;
          color: #343a40;
          .data {
            text-overflow: ellipsis;
            overflow-x: hidden;
          }
        }
        .item-title {
          font-size: 14px;
          color: #98a6ad;
        }
      }
    }
  }

  .course-progress {
    padding: 22px 0 4px;
    background: #f3f7f9;
    .progress-title {
      position: relative;
      .progress-icon {
        position: absolute;
        left: -30px;
      }
    }
    .progress-item {
      .item-title {
        font-size: 16px;
        color: #343a40;
      }
      .item-progress {
        font-size: 32px;
        font-weight: bold;
      }
      .item-content {
        font-size: 14px;
        color: #98a6ad;
      }
    }
  }
  .week-access {
    ::v-deep .el-table {
      thead {
        th.el-table__cell {
          background-color: #fff;
        }
      }
      .first-column {
        background-color: #f3f7f9 !important;
      }
    }
  }
  .chart-box {
    .chart-title {
      margin-bottom: 36px;
      font-size: 16px;
      font-weight: bold;
      color: #343a40;
    }
  }
}
@media screen and (max-width: 1920px) {
  .student-base-info {
    .student-info {
      flex-direction: column;
    }
  }
  .student-study-info {
    .course-info {
      .info-item {
        width: 33.333%;
        margin-top: 32px;
      }
    }
  }
  .course-progress {
    flex-direction: column;
  }
}
@media screen and (max-width: 1368px) {
}
</style>
